export enum NotificationType {
  Error,
  Info,
  Success,
}
